// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
// Selectors
import { appIsRefreshingCurrentBoardSelector } from '../../../offline/appServerConnection/appServerReconnectionSelector';

// Components
import BreadcrumbList from '../../breadcrumbs/Components/BreadcrumbList';
import useStalledBoolean from '../../../utils/react/useStalledBoolean';

// Styles
import './AppHeaderBreadcrumbs.scss';

const TRUNCATE_BUTTON_WIDTH = 50;

const mapStateToProps = createStructuredSelector({
    isRefreshingCurrentBoard: appIsRefreshingCurrentBoardSelector,
});

const AppHeaderBreadcrumbs = (props) => {
    const {
        currentBoardId,
        rootBoardId,
        breadcrumbObj,
        isLoadingBreadcrumbs,
        isRefreshingCurrentBoard,
        availableWidth,
    } = props;

    const isSyncing = useStalledBoolean(isRefreshingCurrentBoard, 2000);

    // 20 is padding
    const availableBreadcrumbsWidth = availableWidth - TRUNCATE_BUTTON_WIDTH - 20;

    if (isLoadingBreadcrumbs) {
        return (
            <BreadcrumbList
                isLoading
                breadcrumbObj={{
                    complete: true,
                    detatched: false,
                    path: [rootBoardId],
                    fullPath: [rootBoardId],
                }}
                currentBoardId={currentBoardId}
                rootBoardId={rootBoardId}
            />
        );
    }

    return breadcrumbObj.detached ? (
        <BreadcrumbList
            isSyncing={isSyncing}
            breadcrumbObj={{
                complete: true,
                detatched: false,
                path: [rootBoardId],
                fullPath: [rootBoardId],
            }}
            currentBoardId={currentBoardId}
            rootBoardId={rootBoardId}
        />
    ) : (
        <BreadcrumbList
            isSyncing={isSyncing}
            availableBreadcrumbsWidth={availableBreadcrumbsWidth}
            breadcrumbObj={breadcrumbObj}
            currentBoardId={currentBoardId}
            rootBoardId={rootBoardId}
        />
    );
};

AppHeaderBreadcrumbs.propTypes = {
    currentBoardId: PropTypes.string,
    rootBoardId: PropTypes.string,
    isLoadingBreadcrumbs: PropTypes.bool,
    isRefreshingCurrentBoard: PropTypes.bool,
    breadcrumbObj: PropTypes.object,
    availableWidth: PropTypes.number,
};

export default connect(mapStateToProps)(AppHeaderBreadcrumbs);
